export const toGenericUrl = url =>
  '/' +
  url
    .split('/')
    .map(part => (part.startsWith(':') ? '*' : part))
    .filter(part => !!part)
    .join('/');

export const userHasPermissions = (permissions, url, method) => {
  const permission = permissions.find(
    p => p.url === toGenericUrl(url) && p.method === method
  );
  return !!permission;
};
